import PieChart from "common/Charts/PieChart/PieChart";
import React, { useMemo } from "react";
import {
  selectCoinAccountsPrecision,
  selectUniqueCoinAccountsData,
} from "@shared/slices/portfolio.slice";
import TextWithPrecisionAndIcon from "common/Text/TextWithPrecisionAndIcon";
import { PORTFOLIO_DATA_CLIENT_HEADER } from "@shared/features/portfolio/constants";
import { GetCoinExtraExchangesDataRequest, PrecisionType } from "@shared/types";
import { usePortfolioPieChart } from "@shared/features/portfolio/hooks";
import { useBottomNavigator } from "utils/hooks/misc";
import { SkipToken } from "@reduxjs/toolkit/query";

interface CoinAccountsPieChartProps {
  args: GetCoinExtraExchangesDataRequest | SkipToken;
}

export const CoinAccountsPieChart = ({ args }: CoinAccountsPieChartProps) => {
  const dataSelector = useMemo(() => {
    return selectUniqueCoinAccountsData(args);
  }, [args]);
  const { pieChartData, total } = usePortfolioPieChart({
    dataSelector: dataSelector,
    nameHeader: PORTFOLIO_DATA_CLIENT_HEADER,
  });
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const precisionSelector = useMemo(
    () => selectCoinAccountsPrecision(args),
    [args]
  );

  const totalText = useMemo(
    () => (
      <TextWithPrecisionAndIcon
        precisionSelector={precisionSelector}
        precisionType={PrecisionType.AMOUNT}
        text={total}
        round={true}
      />
    ),
    [total, precisionSelector]
  );

  return (
    <PieChart
      data={pieChartData}
      chartName={""}
      total={totalText}
      numGridItems={2}
      chartParentElementId="coin-accounts-chart"
      tooltipElementId="coin-accounts-chart-tooltip"
      isMobileMainPageChart={isBottomNavigator}
      isTwoLinesEllipsis={true}
    />
  );
};

export default React.memo(CoinAccountsPieChart);
